/**
 * Sticky add-to-cart bar — shows when main buy form is off-screen.
 * Prices mirror the main buy box (active purchase tile + Add to Cart button).
 */
(function () {
  const section = document.querySelector(".v4-pdp");
  const form = document.getElementById("fb-v4-pdp-form");
  const bar = document.getElementById("v4-pdp-sticky-bar");
  if (!section || !form || !bar) return;

  const qtyInput = document.getElementById("v4-pdp-quantity");
  const qtyDisplay = bar.querySelector(".v4-pdp-sticky-bar__qty-val");
  const priceEl = bar.querySelector(".v4-pdp-sticky-bar__price");
  const purchaseTypeEl = bar.querySelector(".v4-pdp-sticky-bar__purchase-type");
  const stickyCta = document.getElementById("v4-pdp-sticky-cta");
  const mainCta = document.getElementById("v4-add-to-cart");
  const imgEl = bar.querySelector(".v4-pdp-sticky-bar__img");

  function getQty() {
    return Math.max(1, Number(qtyInput?.value) || 1);
  }

  function unitPriceFromActiveTile() {
    const priceNode = section.querySelector(".v4-pdp__purchase-tile.--active .v4-pdp__purchase-price");
    if (!priceNode) return "";
    for (const node of priceNode.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        return node.textContent.trim();
      }
    }
    return priceNode.textContent.replace(/\s*\/\s*bottle\s*/i, "").trim();
  }

  function purchaseLabelFromActiveTile() {
    const labelNode = section.querySelector(".v4-pdp__purchase-tile.--active .v4-pdp__purchase-label");
    return labelNode ? labelNode.textContent.trim() : "";
  }

  function syncStickyPricing() {
    const unitPrice = unitPriceFromActiveTile();
    const purchaseLabel = purchaseLabelFromActiveTile();
    const activeTile = section.querySelector(".v4-pdp__purchase-tile.--active");
    const isSubscribe = activeTile?.dataset.purchase === "subscribe";
    const freeshipEl = bar.querySelector(".v4-pdp-sticky-bar__freeship");

    if (purchaseTypeEl && purchaseLabel) purchaseTypeEl.textContent = purchaseLabel;
    if (freeshipEl) freeshipEl.hidden = !isSubscribe;
    if (priceEl && unitPrice) priceEl.textContent = unitPrice;

    if (stickyCta && mainCta) {
      const label = (mainCta.textContent || "").trim();
      stickyCta.textContent = label.replace(/^Add to Cart\s*-\s*/i, "Add to Cart — ");
      const aria = mainCta.getAttribute("aria-label");
      if (aria) stickyCta.setAttribute("aria-label", aria.replace(/\s-\s/, " — "));
    }
  }

  function setQty(next) {
    const val = Math.max(1, Math.min(99, next));
    if (qtyInput) qtyInput.value = String(val);
    if (qtyDisplay) qtyDisplay.textContent = String(val);
  }

  function syncHeroImage() {
    if (!imgEl || imgEl.tagName !== "IMG") return;
    const hero = section.querySelector('.v4-pdp__main-img[data-slide="0"]');
    if (!hero) return;
    const src = hero.currentSrc || hero.src;
    if (src && imgEl.src !== src) imgEl.src = src;
  }

  document.addEventListener("v4:purchase-changed", syncStickyPricing);

  if (mainCta && typeof MutationObserver !== "undefined") {
    new MutationObserver(syncStickyPricing).observe(mainCta, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  bar.querySelectorAll("[data-qty-delta]").forEach((btn) => {
    btn.addEventListener("click", () => {
      setQty(getQty() + Number(btn.dataset.qtyDelta || 0));
    });
  });

  stickyCta?.addEventListener("click", () => {
    form.requestSubmit();
  });

  const observer = new IntersectionObserver(
    ([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle("--visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      document.documentElement.classList.toggle("v4-pdp-sticky-bar-open", show);
    },
    { threshold: 0.12, rootMargin: "0px 0px -12px 0px" },
  );

  observer.observe(form);
  syncHeroImage();
  syncStickyPricing();
  window.addEventListener("load", syncStickyPricing);
  requestAnimationFrame(syncStickyPricing);
})();
